import { MULTIPART_FORM_DATA_HEADERS } from '@/constants';
import requester from '@/lib/axios';
import Hackathon from '@/models/Hackathon';
import { BaseFilters, ListServiceFunc } from '@/models/Service';
import { bannerImgConverter, convertToFormData } from '@/utils/convertToFormData';

export type HackathonFilters = BaseFilters & {
  edition?: number;
  date?: string;
  lastHackathon?: boolean;
};

export type HackathonDTO = Omit<Hackathon, 'banner'> & {
  banner?: File | null;
};

const toHackathonFormData = (hackathon: Partial<HackathonDTO>) =>
  convertToFormData(hackathon, { banner: bannerImgConverter });

export const listHackathons: ListServiceFunc<
  Hackathon,
  HackathonFilters
> = async params => {
  const { data } = await requester().get(`hackathons/`, {
    params,
  });
  return data;
};

export const createHackathon = async (hackathon: Omit<HackathonDTO, 'id'>) => {
  const { data } = await requester().post<Hackathon>(
    'hackathons/',
    toHackathonFormData(hackathon),
    { headers: MULTIPART_FORM_DATA_HEADERS },
  );
  return data;
};

export const updateHackathon = async (
  hackathonId: number,
  hackathon: Partial<HackathonDTO>,
) => {
  const { data } = await requester().patch<Hackathon>(
    `hackathons/${hackathonId}/`,
    toHackathonFormData(hackathon),
    { headers: MULTIPART_FORM_DATA_HEADERS },
  );
  return data;
};

export const deleteHackathon = async (hackathonId: number) => {
  const { data } = await requester().delete<Hackathon>(
    `hackathons/${hackathonId}/`,
  );
  return data;
};
